import { api } from './client'

/**
 * ADR-019 (Equal Point): client di `BusinessLinesController` (`/api/business-lines`). `mine` vale per ogni
 * utente (i rami che può aprire e se vede la vista Generale); le modifiche sono solo Admin.
 */
export interface BusinessLine {
  id: number
  slug: string
  name: string
  color: string
  sortOrder: number
}

export interface BusinessLineWithDepartments extends BusinessLine {
  isActive: boolean
  departments: { id: number; name: string }[]
}

export interface MyBusinessLines {
  general: boolean
  lines: BusinessLine[]
}

export const businessLinesApi = {
  mine: () => api<MyBusinessLines>('/api/business-lines/mine'),
  list: (all = false) => api<BusinessLineWithDepartments[]>(`/api/business-lines${all ? '?all=true' : ''}`),
  assignDepartment: (departmentId: number, businessLineId: number | null, changeReason?: string) =>
    api<void>(`/api/business-lines/departments/${departmentId}`, {
      method: 'PUT', body: JSON.stringify({ businessLineId, changeReason }),
    }),
  userLines: (userId: number) => api<number[]>(`/api/business-lines/users/${userId}`),
  setUserLines: (userId: number, businessLineIds: number[]) =>
    api<void>(`/api/business-lines/users/${userId}`, { method: 'PUT', body: JSON.stringify({ businessLineIds }) }),
}
